import { TableCell, TableRow } from "components/RFQ/Table";

export const SkeletonRow = () => {
	const SkeletonCell = <div className="h-6 w-full animate-pulse bg-gray-300" />;
	return (
		<TableRow>
			<TableCell>{SkeletonCell}</TableCell>
			<TableCell>{SkeletonCell}</TableCell>
			<TableCell>{SkeletonCell}</TableCell>
			<TableCell>{SkeletonCell}</TableCell>
		</TableRow>
	);
};
